import {GET, POST} from '../index'
export const changeUserPass = (data) => {
  return POST('/change/pass', data)
}
// 获取权限菜单
export const getUserMenu = () => {
  return GET('/menu')
}
// 人员列表
export const userList = (data) => {
  return GET('/personnel/list', data)
}
// 角色列表
export const userRoles = () => {
  return GET('/personnel/roles')
}
// 添加人员
export const addUser = (data) => {
  return POST('/personnel/add', data)
}
// 编辑人员
export const editUser = (data) => {
  return POST('/personnel/edit', data)
}
// 获取人员信息
export const userInfo = (data) => {
  return GET('/personnel/info', data)
}
// 删除人员
export const delUser = (data) => {
  return GET('/personnel/del', data)
}

// 职能列表
export const roleList = (data) => {
  return GET('/role/list', data)
}
// 添加职能
export const addRole = (data) => {
  return POST('/role/add', data)
}
// 职能信息
export const roleInfo = (data) => {
  return GET('/role/info', data)
}
// 编辑职能
export const editRole = (data) => {
  return POST('/role/edit', data)
}
// 删除职能
export const delRole = (data) => {
  return GET('/role/del', data)
}

// 菜单列表
export const menuAll = () => {
  return GET('/menu/all')
}
// 添加菜单
export const addMenu = (data) => {
  return POST('/menu/add', data)
}

// 更新菜单
export const updateMenu = (data) => {
  return POST('/menu/update', data)
}

// 删除菜单
export const deleteMenu = (data) => {
  return POST('/menu/del', data)
}



// WEBPACK FOOTER //
// ./src/api/auth/index.js